import React, { Component } from 'react';
import Social from '../components/Social';
class Contact extends Component {
    render() {
        return (
            <div className="condiv">
            <h1 className="subtopic">Contact Me</h1>
            <h1><hr /></h1>
            <br />
            <h3>Email  :   dineshgiri1542@gmail.com</h3>
            
            <Social />
            </div>
            )
        }
    }
    
    export default Contact
    